var map = {
	"./abkhazia.svg": "7005",
	"./afghanistan.svg": "55ae",
	"./alandislands.svg": "f20a",
	"./albania.svg": "647a6",
	"./algeria.svg": "4ca9",
	"./americansamoa.svg": "e0cf",
	"./andorra.svg": "3b6b",
	"./angola.svg": "ab18",
	"./anguilla.svg": "19c2",
	"./antigua.svg": "b8b0",
	"./antiguaandbarbuda.svg": "3830",
	"./argentina.svg": "04a4",
	"./armenia.svg": "e992",
	"./aruba.svg": "ef9e",
	"./australia.svg": "daa7",
	"./austria.svg": "c8cd",
	"./azerbaijan.svg": "803a",
	"./azoresislands.svg": "9778",
	"./bahamas.svg": "8bd4",
	"./bahrain.svg": "1cd7",
	"./balearicislands.svg": "678b",
	"./bangladesh.svg": "4746",
	"./barbados.svg": "3050",
	"./basquecountry.svg": "bcd5",
	"./belarus.svg": "1927",
	"./belgium.svg": "e9af",
	"./belize.svg": "555b",
	"./benin.svg": "30b3",
	"./bermuda.svg": "a017",
	"./bhutan.svg": "a6b1",
	"./bolivia.svg": "d20a",
	"./bonaire.svg": "de2e",
	"./bosniaandherzegovina.svg": "e76d",
	"./botswana.svg": "f0aa",
	"./brazil.svg": "fcc5",
	"./britishcolumbia.svg": "c78e",
	"./britishindianoceanterritory.svg": "8dde",
	"./britishvirginislands.svg": "98f8",
	"./brunei.svg": "010f",
	"./bulgaria.svg": "a7b5",
	"./burkinafaso.svg": "43e4",
	"./burundi.svg": "403b",
	"./caboverde.svg": "3215",
	"./cambodia.svg": "6c3f",
	"./cameroon.svg": "3c39",
	"./canada.svg": "c8f7",
	"./canaryislands.svg": "1efd",
	"./capeverde.svg": "ba1d",
	"./caymanislands.svg": "0b9f",
	"./centralafricanrepublic.svg": "c882",
	"./ceuta.svg": "b024",
	"./chad.svg": "78c2",
	"./chile.svg": "e7a6",
	"./china.svg": "7334",
	"./christmasisland.svg": "0834",
	"./cocosisland.svg": "d38d",
	"./colombia.svg": "6fff",
	"./comoros.svg": "f1d5",
	"./congo.svg": "88e1",
	"./cookislands.svg": "ae3f",
	"./corsica.svg": "2e63",
	"./costarica.svg": "3f1a",
	"./cotedivoire.svg": "da83",
	"./croatia.svg": "076b",
	"./cuba.svg": "708c",
	"./curacao.svg": "fc26",
	"./cyprus.svg": "47a5",
	"./czechia.svg": "4b0d2",
	"./czechrepublic.svg": "53ab",
	"./democraticrepublicofcongo.svg": "4617",
	"./democraticrepublicofthecongo.svg": "e491",
	"./denmark.svg": "6547",
	"./djibouti.svg": "7123",
	"./dominica.svg": "7499",
	"./dominicanrepublic.svg": "246f",
	"./easttimor.svg": "31bf",
	"./ecuador.svg": "ac6af",
	"./egypt.svg": "da4b",
	"./elsalvador.svg": "ca3f",
	"./england.svg": "0757",
	"./equatorialguinea.svg": "3a05",
	"./eritrea.svg": "dc64",
	"./estonia.svg": "86f8",
	"./eswatini.svg": "b713",
	"./ethiopia.svg": "ef4b",
	"./europeanunion.svg": "be6e",
	"./falklandislands.svg": "a4ca",
	"./fiji.svg": "fe26",
	"./finland.svg": "0012",
	"./france.svg": "2f1e",
	"./frenchpolynesia.svg": "6319",
	"./gabon.svg": "39cc",
	"./galapagosislands.svg": "7696",
	"./gambia.svg": "de0f",
	"./georgia.svg": "5392",
	"./germany.svg": "3387",
	"./ghana.svg": "7063",
	"./gibraltar.svg": "aeb3",
	"./greece.svg": "a6bc",
	"./greenland.svg": "ea5e",
	"./grenada.svg": "aa75",
	"./guam.svg": "edb7",
	"./guatemala.svg": "9e691",
	"./guernsey.svg": "97b9",
	"./guinea.svg": "36ab",
	"./guineabissau.svg": "0dfd",
	"./guyana.svg": "ad92",
	"./haiti.svg": "bfd5",
	"./hawaii.svg": "9a5c",
	"./holysee.svg": "adef",
	"./honduras.svg": "79e6",
	"./hongkong.svg": "999e",
	"./hungary.svg": "51e5",
	"./iceland.svg": "ac73",
	"./india.svg": "6d44",
	"./indonesia.svg": "143d",
	"./iran.svg": "8245",
	"./iraq.svg": "e41b",
	"./ireland.svg": "6800",
	"./isleofman.svg": "b9a2",
	"./israel.svg": "859e",
	"./italy.svg": "4a35",
	"./ivorycoast.svg": "103c",
	"./jamaica.svg": "d21e",
	"./japan.svg": "7ce64",
	"./jersey.svg": "517f",
	"./jordan.svg": "bf30",
	"./kazakhstan.svg": "4da0",
	"./kenya.svg": "958d",
	"./kiribati.svg": "82bd",
	"./kosovo.svg": "c3b3",
	"./kuwait.svg": "bbaec",
	"./kwait.svg": "2492",
	"./kyrgyzstan.svg": "f02e",
	"./laos.svg": "f027",
	"./latvia.svg": "e742",
	"./lebanon.svg": "d2de",
	"./lesotho.svg": "77c4",
	"./liberia.svg": "1022",
	"./libya.svg": "cbdf",
	"./liechtenstein.svg": "aaa0",
	"./lithuania.svg": "e7cf",
	"./luxembourg.svg": "eba3",
	"./macao.svg": "4b4a",
	"./madagascar.svg": "0b18",
	"./madeira.svg": "ebb4",
	"./malawi.svg": "d623",
	"./malaysia.svg": "d006",
	"./maldives.svg": "2dcf",
	"./mali.svg": "742f",
	"./malta.svg": "398f",
	"./marshallisland.svg": "f4eb",
	"./marshallislands.svg": "b8bb",
	"./martinique.svg": "ace5",
	"./mauritania.svg": "5e1d",
	"./mauritius.svg": "201a",
	"./melilla.svg": "e6308",
	"./mexico.svg": "a5fb",
	"./micronesia.svg": "9b3d",
	"./moldova.svg": "8703",
	"./monaco.svg": "b328",
	"./mongolia.svg": "49ed",
	"./montenegro.svg": "67e9",
	"./montserrat.svg": "07a8",
	"./morocco.svg": "2f2c",
	"./mozambique.svg": "fb22",
	"./myanmar.svg": "1ff7",
	"./namibia.svg": "2015",
	"./nato.svg": "461d",
	"./nauru.svg": "bde6",
	"./nepal.svg": "784e",
	"./netherlands.svg": "affc",
	"./newzealand.svg": "c305",
	"./nicaragua.svg": "ef02",
	"./niger.svg": "17f7",
	"./nigeria.svg": "a75e",
	"./niue.svg": "01a4",
	"./norfolkisland.svg": "b52c",
	"./northerncyprus.svg": "daa1",
	"./northernmarianasislands.svg": "3e5e",
	"./northkorea.svg": "5af0",
	"./northmacedonia.svg": "586e",
	"./norway.svg": "567a",
	"./oman.svg": "d306",
	"./ossetia.svg": "a761",
	"./pakistan.svg": "d690",
	"./palau.svg": "2934",
	"./palestine.svg": "5811",
	"./palestinestate.svg": "5cbd",
	"./panama.svg": "d056",
	"./papuanewguinea.svg": "0a3f",
	"./paraguay.svg": "a46f",
	"./peru.svg": "b209",
	"./philippines.svg": "e8ca",
	"./pitcairnislands.svg": "0fb5",
	"./poland.svg": "f0fa",
	"./portugal.svg": "7a88",
	"./puertorico.svg": "dd5a",
	"./qatar.svg": "6776",
	"./rapanui.svg": "1cf2",
	"./republicofmacedonia.svg": "4d85",
	"./republicofthecongo.svg": "6267",
	"./romania.svg": "f519",
	"./russia.svg": "9eb7",
	"./rwanda.svg": "d09a",
	"./sabaisland.svg": "2074",
	"./sahrawiarabdemocraticrepublic.svg": "6d311",
	"./saintkittsandnevis.svg": "cd56",
	"./saintlucia.svg": "9565",
	"./saintvincentandthegrenadines.svg": "1354",
	"./samoa.svg": "838a",
	"./sanmarino.svg": "6b3b",
	"./saotomeandprince.svg": "6873",
	"./saotomeandprincipe.svg": "437c",
	"./sardinia.svg": "3561",
	"./saudiarabia.svg": "dd4e",
	"./scotland.svg": "67f0",
	"./senegal.svg": "139b",
	"./serbia.svg": "2636",
	"./seychelles.svg": "5280",
	"./sicily.svg": "4b86",
	"./sierraleone.svg": "f632",
	"./singapore.svg": "4a77",
	"./sinteustatius.svg": "aa90",
	"./sintmaarten.svg": "7588",
	"./slovakia.svg": "2335",
	"./slovenia.svg": "d523",
	"./solomonislands.svg": "71a1",
	"./somalia.svg": "0e34",
	"./somaliland.svg": "3ece",
	"./southafrica.svg": "5c39",
	"./southkorea.svg": "996c",
	"./southsudan.svg": "661d",
	"./spain.svg": "ee4d",
	"./srilanka.svg": "e2fb",
	"./stbarts.svg": "45e4",
	"./stlucia.svg": "4908",
	"./stvincentandthegrenadines.svg": "db43",
	"./sudan.svg": "dd72",
	"./suriname.svg": "a4b6",
	"./swaziland.svg": "3939",
	"./sweden.svg": "5708",
	"./switzerland.svg": "61b9",
	"./syria.svg": "4295",
	"./taiwan.svg": "456e",
	"./tajikistan.svg": "0b8d",
	"./tanzania.svg": "8cee",
	"./thailand.svg": "e3f4",
	"./tibet.svg": "37bf",
	"./timorleste.svg": "873f",
	"./togo.svg": "c871",
	"./tokelau.svg": "1752",
	"./tonga.svg": "d003",
	"./transnistria.svg": "06ec",
	"./trinidadandtobago.svg": "6a29",
	"./tunisia.svg": "27ea",
	"./turkey.svg": "1f4e",
	"./turkmenistan.svg": "52c0",
	"./turksandcaicos.svg": "11a6",
	"./tuvalu.svg": "5d03",
	"./uganda.svg": "fd85",
	"./ukraine.svg": "ce65c",
	"./unitedarabemirates.svg": "766f",
	"./unitedkingdom.svg": "a5b9",
	"./unitednations.svg": "a794",
	"./unitedstates.svg": "c334",
	"./uruguay.svg": "1b48",
	"./uzbekistan.svg": "b5a7",
	"./vanuatu.svg": "f485",
	"./vaticancity.svg": "3888",
	"./venezuela.svg": "ef38",
	"./vietnam.svg": "c802",
	"./virginislands.svg": "710d",
	"./wales.svg": "6b97",
	"./yemen.svg": "6d09",
	"./zambia.svg": "ecd0",
	"./zimbabwe.svg": "48f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9a5";